import {BusinessDataService} from '../data-repositories/business-data.service';
import {User} from '../models/user';
import {UserStore} from '../models/user-store';
import {AuthService} from '../repositories/auth.service';

export class UserDependentComponent {
  protected userEntity: User = {} as User;
  private timerId: any;
  private awaitableActions = new Array<() => void>();
  private awaitableErrorActions = new Array<(e: any) => void>();

  constructor(
    private businessDataService: BusinessDataService,
    private authService: AuthService) {
    this.Initialize();
  }

  private Dispose() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    if (!this.authService.isLoggedIn() || !!!this.userEntity.id) {
      return;
    }

    this.businessDataService.sendUserUpdate(this.userEntity, () => {
    });
  }

  private Initialize(): void {
    this.businessDataService.requestForUpdateUser().subscribe((event) => {
      this.userEntity = event.user as User;
      this.RescheduleSendUpdate(
        event.immediately as boolean,
        event.action as () => void,
        event.errorAction as (e: any) => void
      );
    });

    window.onbeforeunload = () => {
      this.Dispose();
    };
  }

  private RescheduleSendUpdate(immediately: boolean, action?: () => void, errorAction?: (e: any) => void): void {
    if (!!action) {
      this.awaitableActions.push(action);
    }
    if (!!errorAction) {
      this.awaitableErrorActions.push(errorAction);
    }

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    const timeout = immediately ? 0 : 5000;
    const flushErrors = (error: any) => {
      const errors = this.awaitableErrorActions.slice();
      this.awaitableActions.length = 0;
      this.awaitableErrorActions.length = 0;
      this.timerId = null;
      errors.forEach((act) => act(error));
    };

    this.timerId = setTimeout(() => {
      if (!this.authService.isLoggedIn() || !!!this.userEntity.id) {
        flushErrors(new Error('not-authorized'));
        return;
      }

      this.businessDataService.sendUserUpdate(
        this.userEntity,
        (result) => {
          const actions = this.awaitableActions.slice();
          this.awaitableActions.length = 0;
          this.awaitableErrorActions.length = 0;
          this.timerId = null;

          this.userEntity.timestamp = result.timestamp;
          this.businessDataService.SetUser({
            model: this.userEntity,
            initial: false,
          } as UserStore);

          actions.forEach((act) => act());
        },
        (error) => flushErrors(error)
      );
    }, timeout);
  }
}
